import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewSingleClient = (id) => {
  return useQuery({
    queryKey: ["client", id],
    queryFn: async () => {
      const res = await api.get(`/client/${id}`);
      return res.data;
    },
    enabled: !!id, // prevents unnecessary call
  });
};